/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: b4e9f3eb3ca7
 */

import * as z from "zod";
import { streamingProfilesDeleteStreamingProfile } from "../../funcs/streamingProfilesDeleteStreamingProfile.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  name: z.string().describe("The name of the streaming profile."),
};

export const tool$streamingProfilesDeleteStreamingProfile: ToolDefinition<
  typeof args
> = {
  name: "delete-streaming-profile",
  description:
    `Delete custom streaming profile or revert built-in profile to the original settings`,
  scopes: ["builder"],
  annotations: {
    "title": "Delete Streaming Profile",
    "destructiveHint": true,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await streamingProfilesDeleteStreamingProfile(
      client,
      args.name,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
